import React, { useState, useEffect } from 'react'  
import Dashboard from './DashboardDemo/Dashboard'

function DashboardMain() {   
    return (  
        <Dashboard/>
    )  
}  
  
export default Dashboard  